import {onError} from 'apollo-link-error';
import Notifier from '../../ui/Notifier';
import {REDIRECT_401_URL} from '../../../util/URLUtils';

const errorLink = onError( ( {graphQLErrors, networkError/*, operation, forward*/} ) => {
    if ( graphQLErrors ) {
        graphQLErrors.map( ( err ) => {
            const {message, locations, path, extensions} = err;

            !window.__IS_TEST_RUNNER__ && console.error(
                `[GraphQL error]:
                Message: ${message.replace( 'GraphQL error: ', '' )},
                Location: ${locations.map( l => {
                    try { return JSON.stringify( l ) }
                    catch ( err ) { return 'unknown'}
                } )},
                Path: ${path}`
            );

            if ( extensions ) {
                switch ( extensions.code ) {
                    // handle unauthorized (401) errors from anon or expired tokens
                    case 'Unauthorized':
                        window.location.replace( REDIRECT_401_URL );
                        break;
                }
            }

            // todo - log these exceptions to Sentry
            // todo - Handle these errors in context instead of using a global Toast message
            if ( path ) {
                switch ( path.join( '.' ) ) {
                    case 'addLineItems':
                    case 'updateLineItems':
                    case 'deleteLineItems':
                        Notifier.error( 'Sorry, there was a problem while trying to modify your cart.' );
                }
            }
        } );
    }

    if ( networkError ) {
        // todo - log these exceptions to Sentry
        console.error( `[Network error]: ${networkError}` );
    }
} );

export default errorLink;
